import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-export-preference__form" }
const _hoisted_2 = { class: "settings-export-preference__description typographies-paragraph-small-regular" }

import Card from 'vcomponents/common/card/Card.vue';
import Heading from 'vcomponents/common/Heading/Heading.vue';
import { savePreferences } from 'api/settings/export/exportPreferenceService';
import { ref, watch, inject } from 'vue';
import type { Translator } from 'types/injects/translator.type';
import type { PushToast } from 'types/injects/pushToast.type';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportPreference',
  props: {
    settings: {
        type: Object,
        required: true,
    },
},
  setup(__props) {

const $pushToast = inject('$pushToast') as PushToast;
const $t = inject('$t') as Translator;

const props = __props;

const loading = ref(false);
const settingUpdated = ref(false);
const settings = ref(props.settings);

watch(
    settings,
    () => {
        settingUpdated.value = true;
    },
    { deep: true },
);

const separatorOptions = [
    { label: $t.__('export.settings.separator.semicolon'), value: 'semicolon' },
    { label: $t.__('export.settings.separator.tab'), value: 'tab' },
    { label: $t.__('export.settings.separator.comma'), value: 'comma' },
];
const wrapperOptions = [
    { label: $t.__('export.settings.wrapper.quote'), value: 'quote' },
    { label: $t.__('export.settings.wrapper.simplequote'), value: 'simplequote' },
    { label: $t.__('export.settings.wrapper.none'), value: 'none' },
];
const textFormatsOptions = [
    { label: $t.__('export.settings.textFormat.with'), value: 'with' },
    { label: $t.__('export.settings.textFormat.without'), value: 'without' },
];

function handleSave() {
    loading.value = true;
    savePreferences(settings.value)
        .then(() => {
            settingUpdated.value = false;
            $pushToast({
                type: CompassEnums.ToastType.SUCCESS,
                icon: true,
                text: $t.__('export.settings.success_message'),
                close: true,
            });
        })
        .catch(() => {
            $pushToast({
                type: CompassEnums.ToastType.ERROR,
                icon: true,
                text: $t.__('common.labels.toast.error'),
                close: true,
            });
        })
        .finally(() => {
            loading.value = false;
        });
}

return (_ctx: any,_cache: any) => {
  const _component_CompassDropdownOption = _resolveComponent("CompassDropdownOption")!
  const _component_CompassSelect = _resolveComponent("CompassSelect")!
  const _component_CompassFormItem = _resolveComponent("CompassFormItem")!
  const _component_CompassButton = _resolveComponent("CompassButton")!

  return (_openBlock(), _createBlock(Card, { class: "settings-export-preference" }, {
    default: _withCtx(() => [
      _createVNode(Heading, {
        labelTitle: _unref($t).__('export.settings.title'),
        variant: "h2",
        prefixColoredIcon: {
                icon: 'database-smile',
                color: _ctx.CompassEnums.ColoredIconColorType.BRAND,
            }
      }, null, 8 /* PROPS */, ["labelTitle", "prefixColoredIcon"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CompassFormItem, {
          label: _unref($t).__('export.settings.separator'),
          orientation: _ctx.CompassEnums.FormItemOrientation.HORIZONTAL
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CompassSelect, {
              modelValue: settings.value.separator,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((settings.value.separator) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(separatorOptions, (option) => {
                  return _createVNode(_component_CompassDropdownOption, _mergeProps({ ref_for: true }, option, {
                    key: option.value
                  }), null, 16 /* FULL_PROPS */)
                }), 64 /* STABLE_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "orientation"]),
        _createVNode(_component_CompassFormItem, {
          label: _unref($t).__('export.settings.textIdentifier'),
          orientation: _ctx.CompassEnums.FormItemOrientation.HORIZONTAL
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CompassSelect, {
              modelValue: settings.value.wrapper,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settings.value.wrapper) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(wrapperOptions, (option) => {
                  return _createVNode(_component_CompassDropdownOption, _mergeProps({ ref_for: true }, option, {
                    key: option.value
                  }), null, 16 /* FULL_PROPS */)
                }), 64 /* STABLE_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "orientation"]),
        _createVNode(_component_CompassFormItem, {
          label: _unref($t).__('export.settings.textFieldsFormat'),
          orientation: _ctx.CompassEnums.FormItemOrientation.HORIZONTAL
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CompassSelect, {
              modelValue: settings.value.textFormat,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((settings.value.textFormat) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(textFormatsOptions, (option) => {
                  return _createVNode(_component_CompassDropdownOption, _mergeProps({ ref_for: true }, option, {
                    key: option.value
                  }), null, 16 /* FULL_PROPS */)
                }), 64 /* STABLE_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "orientation"]),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref($t).__('export.settings.textFieldsDescription')), 1 /* TEXT */),
        _createVNode(_component_CompassButton, {
          class: "settings-export-preference__save-button",
          label: _unref($t).__('common.actions.save'),
          disabled: !settingUpdated.value,
          loading: loading.value,
          onClick: handleSave
        }, null, 8 /* PROPS */, ["label", "disabled", "loading"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})